import { HfsActionEnum } from 'fleet-data-model';
import type { StoredAssetHfsAction } from '@fleet-bffs/api-contract';

export const parkActionTypes = [
  HfsActionEnum.MOWER_PARK_PERMANENTLY,
  HfsActionEnum.MOWER_PARK_TEMPORARILY,
  HfsActionEnum.MOWER_PARK_POI,
];

export const playActionTypes = [
  HfsActionEnum.MOWER_RESUME_SCHEDULE,
  HfsActionEnum.MOWER_RESUME_OVERRIDE,
  HfsActionEnum.MOWER_OVERRIDE_MOW_TIME,
  HfsActionEnum.MOWER_OVERRIDE_MOW_AREA_TIME,
];

export const pauseActionTypes = [
  HfsActionEnum.MOWER_PAUSE_SCHEDULE,
  HfsActionEnum.MOWER_PAUSE_OVERRIDE,
];

export const getActionEligibleMissionsIds = (
  actions: StoredAssetHfsAction[],
  actionId: HfsActionEnum,
  missionIds: number[]
) => {
  return actions
    .filter(
      (action) =>
        action.hfsAction === actionId &&
        action.metadata !== undefined &&
        missionIds.includes(action.metadata.missionId)
    )
    .map((action) => action.metadata.missionId);
};
